<template>
    <div
        class="vertical-button h-100 w-100 d-flex flex-column"
        :class="mode"
        @click="onSelect"
    >
        <div class="vertical-button__header">
            {{ header }}
        </div>
        <div class="vertical-button__options h-100">
            <div class="vertical-button__upper" ref="optionA" v-bind:style="getStyle(heightOptionA)">
                <slot class="option" name="option-a" />
            </div>
            <div class="vertical-button__lower" ref="optionB"  v-bind:style="getStyle(heightOptionB)">
                <slot class="option" name="option-b" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'verticalButton',
  props: {
    choice: {
      type: String | Number,
    },
    header: {
      type: String,
    },
    selected: {
      type: Boolean,
    },
    shadowed: {
      type: Boolean,
    },
    variant: {
      type: String,
      default: '',
    },
  },
  computed: {
    mode() {
      const colorClass = this.variant ? `vertical-button-${this.variant}` : '';

      if (this.selected) return `vertical-button--selected ${colorClass}`;
      if (this.shadowed) return `vertical-button--unselected ${colorClass}`;
      return colorClass;
    },
  },
  data() {
    return {
      heightOptionA: 0,
      heightOptionB: 0,
    };
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.heightOptionA = this.$refs.optionA.clientHeight;
      this.heightOptionB = this.$refs.optionB.clientHeight;
    },
    getStyle(heightOption) {
      // fix for BQ-735 on samsung mobile browsers, where the component height was not calculated
      // correctly, this code will set an absolute height value on the vertical buttons to
      // circumvent this issue
      if (heightOption !== 0) {
        return {
          height: `${heightOption}px`,
        };
      }
      return {
        height: '50% !important',
      };
    },
    onSelect() {
      this.$emit('select', this.choice);
    },
  },
};
</script>
<style lang="scss">
    .vertical-button {
        border-radius: 1em;
        overflow: hidden;
        cursor: pointer;
    }

    .vertical-button--unselected {
        transition: .2s ease-in-out;
        opacity: 0.7;
    }

    .vertical-button--selected {
        border: 2px solid $bq-silver;
        transform: scale(1.1);
        transition: .2s ease-in-out;

        > .vertical-button__header {
            background-color: $bq-silver;
        }
    }

    .vertical-button__header {
        height: 2em;
        line-height: 2em;
        font-weight: 600;
        text-align: center;
        background: $base_grey-1;
        @media screen and (min-width: 992px) {
            height: 2.25em;
        }
    }

    .vertical-button__options {
        background-color: $base_grey-4;
    }

    .vertical-button__upper {
        border-bottom: 1px dotted grey;
    }

    .vertical-button-bq-orange {
        > .vertical-button__header {
            color: $bq-orange;
        }
    }

    .vertical-button-bq-orange.vertical-button--selected  {
        border: 2px solid $bq-orange;

        > .vertical-button__header {
            color: $bq-white;
            background-color: $bq-orange;
        }
    }

    .vertical-button-bq-burgundy {
        > .vertical-button__header {
            color: $bq-burgundy;
        }
    }

    .vertical-button-bq-burgundy.vertical-button--selected  {
        border: 2px solid $bq-burgundy;

        > .vertical-button__header {
            color: $bq-white;
            background-color: $bq-burgundy;
        }
    }

    .vertical-button-bq-turquoise {
        > .vertical-button__header {
            color: $bq-turquoise;
        }
    }

    .vertical-button-bq-turquoise.vertical-button--selected  {
        border: 2px solid $bq-turquoise;

        > .vertical-button__header {
            color: $bq-white;
            background-color: $bq-turquoise;
        }
    }

    .vertical-button-bq-blue {
        > .vertical-button__header {
            color: $bq-blue;
        }
    }

    .vertical-button-bq-blue.vertical-button--selected  {
        border: 2px solid $bq-blue;

        > .vertical-button__header {
            color: $bq-white;
            background-color: $bq-blue;
        }
    }
</style>
